// @flow

// 2019 October: currently not in use. Keep for future use.
export default class Config {
  constructor(data: Object) {
    Object.assign(this, data);
  }
}
